
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class PosCustomerMasterDialog extends Serenity.EntityDialog<PosCustomerMasterRow, any> {
        protected getFormKey() { return PosCustomerMasterForm.formKey; }
        protected getIdProperty() { return PosCustomerMasterRow.idProperty; }
        protected getLocalTextPrefix() { return PosCustomerMasterRow.localTextPrefix; }
        protected getNameProperty() { return PosCustomerMasterRow.nameProperty; }
        protected getService() { return PosCustomerMasterService.baseUrl; }
        protected getDeletePermission() { return PosCustomerMasterRow.deletePermission; }
        protected getInsertPermission() { return PosCustomerMasterRow.insertPermission; }
        protected getUpdatePermission() { return PosCustomerMasterRow.updatePermission; }

        protected form = new PosCustomerMasterForm(this.idPrefix);

        private loadedState: string;
        constructor() {
            super();


            q.SetCategoryEightColumn(this.form.PosCustomerCode);
            q.SetCategoryFourColumn(this.form.ImagePath);
            q.SetCategoryFullWidth(this.form.BirthDate);
            q.HideCategoryLable(this.element);
            //q.hideImageToolbar(this.form.ImagePath);
            q.hideEditorLabel(this.form.ImagePath);



            if (this.getSaveState()) {
                Serenity.EditorUtils.setReadOnly(this.form.StateId, true);
                Serenity.EditorUtils.setReadOnly(this.form.CityId, true);
            }
            DialogUtils.pendingChangesConfirmation(this.element, () => this.getSaveState() != this.loadedState);
            this.form.CountryId.changeSelect2(e => {
                this.form.StateId.cascadeField = "CountryId";
                this.form.StateId.cascadeValue = this.form.CountryId.value;
                this.form.CityId.cascadeField = "StateId";
                this.form.CityId.cascadeValue = this.form.StateId.value;
                //this.form.CountryId.cascadeField = "id";
                //this.form.NationalityId.cascadeValue = this.form.CountryId.value

                Serenity.EditorUtils.setReadOnly(this.form.StateId, false);

            });
            this.form.StateId.changeSelect2(e => {
                this.form.CityId.cascadeField = "StateId";
                this.form.CityId.cascadeValue = this.form.StateId.value;
                Serenity.EditorUtils.setReadOnly(this.form.CityId, false);

            });

            this.form.AllowCredit.changeSelect2(e => {
                if (this.form.AllowCredit.value == true) {
                    Serenity.EditorUtils.setReadonly(this.form.CreditLimit.element, false);
                } else {
                    Serenity.EditorUtils.setReadonly(this.form.CreditLimit.element, true);
                }

            });
            this.form.Mobile.changeSelect2(e => {
                if (!isNumeric(this.form.Mobile.value)) {
                    Q.alert('Invalid Mobile No');
                    this.form.Mobile.value = "";
                    return;
                }

            });
            this.form.Mobile2.changeSelect2(e => {
                if (!isNumeric(this.form.Mobile.value)) {
                    Q.alert('Invalid Mobile No');
                    this.form.Mobile2.value = "";
                    return;
                }

            });
            function isNumeric(value) {
                return /^-?\d+$/.test(value);
            }
        }
      
    getSaveState() {
        try {
            return $.toJSON(this.getSaveEntity());
        }
        catch (e) {
            return null;
        }
    }

    loadResponse(data) {
        super.loadResponse(data);
        this.loadedState = this.getSaveState();
    }

}
}